import PrimaryButton from "@/components/common/PrimaryButton";
import { LINK_OF_ALL_PAGES } from "const/common";
import Image from "next/image";
import Link from "next/link";

const WorkProcess = () => (
  <div className="bg-primary-black md:px-8 md:py-16 xl:px-10">
    <div className="w-full flex flex-col xl:flex-row items-center">
      <div className="w-full xl:w-1/2">
        <h2 className="text-4xl md:text-6xl md:leading-tight font-normal text-white px-4 md:px-0 mb-2">
          <span>IT Staff Augmentation Process</span>
        </h2>
        <p className="text-base font-normal  text-white text-justify px-4 md:px-0 md:mr-16 mb-4">
          <span>
            IT staff augmentation service is a simple process of expanding your
            team. You share your resource requirement (be it a single resource
            or a team consisting of all kinds of team members) with a clear job
            description, expertise, experience and any other special
            instructions. This can be for your own project or for your end
            client who is looking for a IT staff augmentation company
            (nevermind, we have got you covered with a proper legal
            documentation) or for your business.
          </span>
        </p>
        <p className="text-base font-normal text-white text-justify px-4 md:px-0 [&>a]:text-blue-500 md:mr-16 mb-4">
          <span>
            Our business team will coordinate with the resource management team,
            and will curate the correct people matching the requirements. That’s
            it, have a word with them and book them to be part of your scalable
            team. As we are one of the most trusted and reliable IT staff
            augmentation &&nbsp;
            <Link href={LINK_OF_ALL_PAGES.services.customSoftwareDevelopment}>
            <a className='text-blue-500'>

              Custom Software Development company
            </a>
            </Link>
            &nbsp;you will be working with, so we can commit to build a
            dedicated team for the technologies you require.
          </span>
        </p>
        <div className="pt-6 px-4 md:px-0">
          <PrimaryButton
            arrow={false}
            link={LINK_OF_ALL_PAGES.mainPages.contactUs}
            val="Hire a resource now!"
          />
        </div>
      </div>
      <div className="w-full xl:w-1/2">
        <div className="flex justify-center">
          <div className="min-w-[370px] h-[470px] md:h-[670px] md:min-w-[670px] overflow-hidden flex justify-center items-center px-8 md:px-0">
            <div className="relative animate-outerAnimation">
              <div className="w-full h-auto">
                <Image
                  alt="dotted-border-round"
                  src="/assets/common/dotted-border-round.webp"
                  width={504}
                  height={503}
                />
              </div>
              <div className="absolute -left-3.5 md:-left-9.5 top-22.5 animate-innerAnimation w-2/12 md:w-auto">
                <Image
                  alt="Allocate the work"
                  src="/assets/services/staff-augmentation/allocate-work.webp"
                  title="Allocate the work"
                  width={130}
                  height={130}
                />
              </div>
              <div className="absolute left-7.5 bottom-4.5 md:bottom-2.5 animate-innerAnimation w-2/12 md:w-auto">
                <Image
                  alt="Resource Curation"
                  src="/assets/services/staff-augmentation/resource-curation.webp"
                  title="Resource Curation"
                  width={130}
                  height={130}
                />
              </div>
              <div className="absolute -right-3 md:-right-9.5 top-22.5 animate-innerAnimation w-2/12 md:w-auto">
                <Image
                  alt="Meeting a resource"
                  src="/assets/services/staff-augmentation/meeting-resource.webp"
                  title="Meeting a resource"
                  width={130}
                  height={130}
                />
              </div>
              <div className="absolute right-7.5 bottom-4.5 md:bottom-2.5 animate-innerAnimation w-2/12 md:w-auto">
                <Image
                  alt="Hassle free onboarding"
                  src="/assets/services/staff-augmentation/hassle-free-onboarding.webp"
                  title="Hassle free onboarding"
                  width={130}
                  height={130}
                />
              </div>
              <div className="absolute right-[150px] -top-7.5 md:-top-[50px] animate-innerAnimation w-2/12 md:w-auto">
                <Image
                  alt="Resource Requirement"
                  src="/assets/services/staff-augmentation/resource-requirement.webp"
                  title="Resource Requirement"
                  width={130}
                  height={130}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default WorkProcess;
